import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function TypeDetails() {
  const { t } = useTranslation();

  // Define type keys and structure dynamically with translations
  const typeDetailsData = {
    assets: {
      title: t("assets"),
      description: t("assetsDetails"),
      examples: [
        t("cashInHand"),
        t("bankBalance"),
        t("inventory"),
        t("buildings"),
        t("vehicle"),
      ],
    },
    liabilities: {
      title: t("liabilities"),
      description: t("liabilitiyDetails"),
      examples: [
        t("loans"),
        t("accountsPayable"),
        t("taxesPayable"),
        t("wagesPayable"),
      ],
    },
    income: {
      title: t("income"),
      description: t("incomeDetails"),
      examples: [
        t("salesRevenue"),
        t("serviceIncome"),
        t("interestIncome"),
        t("rentalIncome"),
      ],
    },
    expense: {
      title: t("expense"),
      description: t("expenseDetails"),
      examples: [
        t("rent"),
        t("salaries"),
        t("utilityBills"),
        t("officeSupplies"),
        t("advertising"),
      ],
    },
  };

  const typeKeys = Object.keys(typeDetailsData);
  const [activeTab, setActiveTab] = useState(typeKeys[0]);
  const details = typeDetailsData[activeTab];

  return (
    <div className="mx-auto py-2">
      <div className="py-1 rounded-1 mb-2 bg-theme-headerBg mt-3 px-2 text-theme-color">
        <div className="font-medium text-sm text-center">{t("typeOfGroups")}</div>
      </div>

      {/* Tabs */}
      <div className="flex mb-2">
        {typeKeys.map((key) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`px-4 h-7 text-sm me-2 transition-colors rounded-1 ${
              activeTab === key
                ? `bg-theme-headerBg text-theme-color`
                : `border hover:text-theme-headerBg hover:!border-theme-headerBg`
            }`}
          >
            {typeDetailsData[key].title}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="p-2 bg-white rounded shadow-sm border-t text-sm">
        <p className="mb-1 text-gray-700 fw-medium">{details.description}</p>
        <div className=" mb-2">{t("examples")} :</div>
        <ul className="list-disc list-inside text-gray-600 text-sm">
          {details.examples.map((ex, idx) => (
            <li key={idx}>{ex}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
